import { ContentTypeFilterClause, ExplorableItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { GroupContentType } from '../ContentTypes';
import { getNoDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { Groups } from '../../../userManagement/groups/Groups';

export const GroupDefinition: ExplorableItemDefinition & SpaceDefinition<'group'> = {
  itemType: 'siteuser',
  contentType: 'group',
  singularName: Messages.group,
  pluralName: Messages.groups,
  emptyStateMessage: Messages.groupsEmptyMessage,
  contentFilterKeys: GroupContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  headerIconPath: () => imgPath('spaces_masthead_groups.svg'),
  filterClause: ServerFilterClauses.ContentType(['siteuser']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Groups.all();
  },
  getContentInfo: () => {
  },
  contentSpaceUrl: () => '',
  supportedDisplayModes: ['list'],
};
